/**
 * This function returns mapped string.
 *
 * @param txt - The text to be matched.
 * @param regex - The filter for matching.
 * @param groupName - The group name.
 * @param map - The map function.
 * @returns - A string after matching the text and replacing.
 */
const regexMapGroup = (txt, regex, groupName, map) => {
    const match = txt.match(regex);
    if (match && match.groups && match.groups[groupName]) {
        const originalVal = match.groups[groupName];
        const newValue = map(originalVal);
        const newTxt = txt.replace(match[0], match[0].replace(match[1], newValue));
        return newTxt;
    }
    return txt;
};
export default regexMapGroup;
//# sourceMappingURL=regexMapGroup.js.map